import { ULI_LAYER_CONFIG } from './config.js';

const deviceOutput = window.TCMS.viewtype;
const event = 'click';
const loginSelector = deviceOutput === 'desktop' ? '.c24-customer-login-opener' : '.c24-uliloginlayer-login-opener';
const loginLinkElement = document.querySelector(loginSelector);

const registerSelector = '.c24-customer-register-opener';
const registerLinkElement = document.querySelector(registerSelector);

if (Check24.uliloginlayer) {
    Check24.uliloginlayer.init(ULI_LAYER_CONFIG);
}

const eventListenerLogin = (e) => {
    e.preventDefault();

    if (Check24.uliloginlayer) {

        Check24.uliloginlayer.open();

        Check24.uliloginlayer.closeAfter = function(data) {
            window.location.reload();
        };
    }
};

if (loginLinkElement && ULI_LAYER_CONFIG.api_product) {
    loginLinkElement.addEventListener(event, eventListenerLogin, {
        once: false,
        passive: false,
        capture: true
    });
}

if (registerLinkElement && ULI_LAYER_CONFIG.api_product) {
    registerLinkElement.addEventListener(event, eventListenerLogin, {
        once: false,
        passive: false,
        capture: true
    });
}
